export default __webpack_public_path__ + "static/media/pointer-down.7b61e520.svg";